import { MessageCircle, Instagram, Youtube, Phone, MapPin } from "lucide-react";
import { WHATSAPP_NUMBER, INSTAGRAM_URL, YOUTUBE_URL, openWhatsApp, quickMessage } from "../lib/site";

export default function Contact() {
  return (
    <section className="static-page">
      <p className="chapter-tag"><em>Chapter</em> · Contact</p>
      <h1 className="page-h1" data-testid="contact-heading">Contact Bhoomiza Organics</h1>
      <p className="page-lead">Questions about our products, wholesale enquiries or delivery? We'd love to hear from you.</p>
      <div className="contact-grid">
        <a className="contact-card" href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp">
          <MessageCircle size={22} />
          <span className="contact-label">WhatsApp</span>
          <strong>+91 9672169073</strong>
          <p>Fastest way to reach us — order or ask directly.</p>
        </a>
        <a className="contact-card" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-instagram">
          <Instagram size={22} />
          <span className="contact-label">Instagram</span>
          <strong>@bhoomizaorganics</strong>
          <p>Behind the scenes, product drops and updates.</p>
        </a>
        <a className="contact-card" href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-youtube">
          <Youtube size={22} />
          <span className="contact-label">YouTube</span>
          <strong>Bhoomiza Organics</strong>
          <p>Videos, product stories and recipes.</p>
        </a>
        <div className="contact-card contact-card-static" data-testid="contact-address">
          <MapPin size={22} />
          <span className="contact-label">Based in</span>
          <strong>Jaipur, Rajasthan · India</strong>
          <p>Bhoomiza Organics — a Jaipur-based brand delivering across India.</p>
        </div>
      </div>
      <div className="contact-cta">
        <button className="pbtn pbtn-solid" onClick={() => openWhatsApp(quickMessage)} data-testid="contact-cta">
          <MessageCircle size={18} /> Message us on WhatsApp
        </button>
      </div>
    </section>
  );
}
